import { useQuery } from 'react-apollo';

import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { markErrorAsHandled } from '@confluence/graphql';
import { Attribution, isNotFoundError, isUnauthorizedError } from '@confluence/error-boundary';
import { getMonitoringClient } from '@confluence/monitoring';

import { PremiumGateQuery } from './PremiumGateQuery.graphql';
import type { PremiumGateQuery as PremiumGateQueryData } from './__types__/PremiumGateQuery';

export const usePremiumGate = () => {
	const { edition } = useSessionData();
	const canSkipEntitlementCheck = edition === ConfluenceEdition.PREMIUM;

	const { data, error } = useQuery<PremiumGateQueryData>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		PremiumGateQuery,
		{
			skip: canSkipEntitlementCheck,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.COMPANY_HUB,
			});
		}
		markErrorAsHandled(error);
	}

	return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
